export enum PillTheme {
  NORMAL = "NORMAL", // Partially transparent gray
  PRIMARY_LIGHT = "PRIMARY_LIGHT", // Pastel purple
  LIGHT_PINK = "LIGHT_PINK", // Pastel pink
  DANGER = "DANGER", // Pastel red,
  NEUTRAL_YELLOW = "NEUTRAL_YELLOW", // Pastel yellow
  SUCCESS = "SUCCESS", // Pastel green
  NEUTRAL_BLUE = "NEUTRAL_BLUE", // Pastel blue
  PRIMARY = "PRIMARY", // Solid purple
  SOLID_WHITE = "SOLID_WHITE", // Solid white
  SOLID_PINK = "SOLID_PINK", // Solid pink
  SOLID_RED = "SOLID_RED", // Solid red
  SOLID_ORANGE = "SOLID_ORANGE", // Solid orange
  SOLID_YELLOW = "SOLID_YELLOW", // Solid yellow
  SOLID_GREEN = "SOLID_GREEN", // Solid green
  SOLID_LIGHT_BLUE = "SOLID_LIGHT_BLUE", // Solid light blue
  SOLID_NAVY = "SOLID_NAVY", // Solid navy
  SOLID_BLACK = "SOLID_BLACK", // Solid black
  // Primary-type colors not covered by the legacy enum values above
  BRAND = "BRAND", // brand/primary
  GRAY_BLUE = "GRAY_BLUE", // grayBlue/primary
  WHITE_SUCCESS = "WHITE_SUCCESS", // whiteSuccess/primary
  // Alternate-type variants (dark/solid background)
  GRAY_ALTERNATE = "GRAY_ALTERNATE",
  BRAND_ALTERNATE = "BRAND_ALTERNATE",
  ERROR_ALTERNATE = "ERROR_ALTERNATE",
  WARNING_ALTERNATE = "WARNING_ALTERNATE",
  SUCCESS_ALTERNATE = "SUCCESS_ALTERNATE",
  GRAY_BLUE_ALTERNATE = "GRAY_BLUE_ALTERNATE",
  BLUE_LIGHT_ALTERNATE = "BLUE_LIGHT_ALTERNATE",
  BLUE_ALTERNATE = "BLUE_ALTERNATE",
  INDIGO_ALTERNATE = "INDIGO_ALTERNATE",
  PURPLE_ALTERNATE = "PURPLE_ALTERNATE",
  PINK_ALTERNATE = "PINK_ALTERNATE",
  ORANGE_ALTERNATE = "ORANGE_ALTERNATE",
  BLACK_ALTERNATE = "BLACK_ALTERNATE",
  WHITE_ALTERNATE = "WHITE_ALTERNATE",
  WHITE_SUCCESS_ALTERNATE = "WHITE_SUCCESS_ALTERNATE",
}
